import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import { theme } from '@Themes/themeOverriderFabric';
import { getBaseTheme } from '@Themes';

const { colors, texts, spaces } = getBaseTheme();
// console.log('🚀 ~ file: ScoreCardItem.style.js ~ line 8 ~ getBaseTheme', getBaseTheme());

export const ScoreCard = styled.div`
    margin: 0.625rem 0;
    border-radius: 2px 0 0 2px;
    background-color: ${colors.area.default.backgroundColor};
    border-left: 4px ${({ riskColor }) => riskColor} solid;
    box-shadow: ${`0 0 2px 0 ${theme.palette.boxShadowDark}`};
    line-height: ${texts.sizes.default};
`;

export const TopDiv = styled.div`
    width: 100%;
    cursor: pointer;
    min-height: 70px;
    display: inline-flex;
`;

export const RiskDiv = styled.div`
    width: 30%;
    margin: auto 0;
    padding: ${spaces.default.s};
    // Need for IE10 & IE11
    position: relative;
`;

export const TooltipDiv = styled.div`
    padding-bottom: 0px;
    z-index: 20;
    max-width: 220px;
    position: absolute;
    display: none;
    padding: ${spaces.default.xxs};
    background-color: ${colors.document.text.active.backgroundColor};
    box-shadow: ${`0 2px 8px 0 ${theme.palette.boxShadowDark}`};
    bottom: ${props => (props.index === 0 ? 'initial' : '85%')};

    * {
        ${texts.sizes.xs};
    }
`;

export const InfoDiv = styled.div`
    width: 80%;
    padding: 0 ${spaces.default.xxs};
    margin: ${spaces.default.xxs} 0;
    border-left: ${`1px solid ${theme.palette.dividerBackground}`};

    #info-div {
        display: flex;
        justify-content: space-between;
        position: relative;

        > div {
            > i {
                color: ${colors.control.focus.complementaryForegroundColor};
            }
            :hover {
                ${TooltipDiv} {
                    display: block;
                }
            }
        }

        ${TooltipDiv} {
            margin-bottom: 10px;
            right: 0px;
        }
    }
`;

export const AnswerDiv = styled.div`
    width: 100%;
    margin-top: 4px;
    position: relative;
    display: inline-flex;
    padding-top: ${spaces.inline.xxxs};
    border-top: ${`1px solid ${theme.palette.dividerBackground}`};

    > div#arrows {
        width: 25%;
        // for IE11
        min-width: 60px;
        padding-right: 5px;
        display: inline-flex;
        justify-content: flex-end;
    }
`;

export const QuestionDiv = styled.div`
    > i {
        margin-right: ${spaces.default.xxs};
        font-size: ${texts.sizes.s.fontSize};
    }

    :hover {
        ${TooltipDiv} {
            display: block;
        }
    }
`;
export const ArrowsDiv = styled.div`
    width: 2.25rem;
    display: flex;
    align-items: center;
    margin-right: ${spaces.default.xs};
    line-height: ${texts.sizes.xs.lineHeight};

    > i {
        color: ${colors.control.focus.complementaryForegroundColor};
        &:hover {
            cursor: pointer;
            border-radius: 50%;
            background-color: ${colors.control.disabled.complementaryBackgroundColor};
        }
    }
`;

export const RiskLabel = styled(textblocks.Heading4)`
    width: 19vw;
    max-width: 20vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // IE10 & IE11 fix vertical center
    left: 50%;
    top: 50%;
    position: absolute;
    text-align: center;
    transform: translate(-50%, -50%);
`;

export const ClauseIconWrapper = styled.span`
    display: inline;
    float: right;
    color: ${colors.control.focus.complementaryForegroundColor};
`;

export const BlackLabel = styled(textblocks.Text)`
    display: inline;
    word-break: break-word;
    white-space: pre-wrap;
    word-break: break-all;
    font-size: ${texts.sizes.xs.fontSize};
`;

export const GrayLabel = styled(textblocks.Text)`
    width: 90%;
    word-break: break-word;
    white-space: pre-wrap;
    word-break: break-all;
    display: inline-flex;
    font-size: ${texts.sizes.s.fontSize};
    color: ${theme.palette.textFieldPlaceholder};
`;

export const ExtLabel = styled(textblocks.Text)`
    font-size: ${texts.sizes.xs.fontSize};
`;

export const CollapsableDiv = styled.div`
    margin: 0 ${spaces.default.xxxs};
    border-top: ${`1px solid ${theme.palette.dividerBackground}`};
`;
